import { render, staticRenderFns } from "./Kds2Menu.vue?vue&type=template&id=1a1d5676"
import script from "./Kds2Menu.vue?vue&type=script&lang=js"
export * from "./Kds2Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports